<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <slot name="title">Default title</slot>
            <button type="button" class="close" @click="close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <transition name="search">
            <div class="modal-body py-2" v-show="!uploading">
              <slot name="body">Default body</slot>
            </div>
          </transition>
          <transition name="upload">
            <div class="modal-body py-2" v-show="uploading">
              <slot name="upload">Default body</slot>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ImagePickerModal',
  data () {
    return {
      uploading: false,
      country: false
    }
  },
  mounted () {
    document.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.close()
      }
    })
  },
  methods: {
    close () {
      this.$emit('onClose')
    },
    toggleUploading () {
      this.uploading = !this.uploading
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media (min-width: 576px) {
  .modal-dialog-centered {
    min-height: calc(100% - 0rem);
  }
}

.search-enter-active {
  transition: opacity 0.5s;
}
.search-leave-active {
  transition: opacity 0.1s;
}
.search-enter, .search-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.upload-enter-active {
  transition: opacity 0.5s;
}
.upload-leave-active {
  transition: opacity 0.1s;
}
.upload-enter, .upload-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
